import { render, staticRenderFns } from "./FormRouteLocaleBasic.vue?vue&type=template&id=c9ebcda0&scoped=true&"
import script from "./FormRouteLocaleBasic.vue?vue&type=script&lang=js&"
export * from "./FormRouteLocaleBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ebcda0",
  null
  
)

export default component.exports